import React, { useState } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import CollapsibleDiv from 'react-collapse';
import { useTranslation } from 'react-i18next';
import {
    I18N_SEE_MORE,
    I18N_SEE_LESS,
    COLLAPSIBLE_DIV_CLASS,
    COLLAPS_TEXT_CLASS,
} from './constants';

const SeeMore = props => {

    const {
        selections,
        collapsibleDivClass,
        collapseTextClass,
        collapseExtraClass,
        callback,
        seeMoreText,
        seeLessText,
    } = props;

    const [t] = useTranslation();
    const [isOpened, setIsOpened] = useState(false);
    const collapseClass = classNames(collapseExtraClass, {
        'expanded': isOpened,
    });

    const onClick = () => {
        setIsOpened(prevStatus => {
            return !prevStatus;
        });
        if (callback) {
            callback();
        }
    };

    return (
        <>
            <CollapsibleDiv isOpened={isOpened} className={collapsibleDivClass}>
                { selections }
            </CollapsibleDiv>
            {
                selections.length !== 0
                ? (
                    <h5 className={collapseClass} onClick={onClick}>
                        <span className={collapseTextClass}>
                            { !isOpened ? t(seeMoreText) : t(seeLessText) }
                        </span>
                    </h5>
                )
                : null
            }
        </>
    );
};

SeeMore.propTypes = {
    /* selections to render */
    selections: propTypes.array.isRequired,
    /* CollapsibleDiv component classname */
    collapsibleDivClass: propTypes.string,
    collapseExtraClass: propTypes.string,
    collapseTextClass: propTypes.any,
    /* callbacks after clicked */
    callback: propTypes.func,
    /* default text, for slider filter group it can be markets.hide_all/see_all */
    seeMoreText: propTypes.string,
    seeLessText: propTypes.string,
};

SeeMore.defaultProps = {
    seeMoreText: I18N_SEE_MORE,
    seeLessText: I18N_SEE_LESS,
    collapsibleDivClass: COLLAPSIBLE_DIV_CLASS,
    collapseExtraClass: '',
    collapseTextClass: COLLAPS_TEXT_CLASS,
};

export default SeeMore;
